// extracted by mini-css-extract-plugin
export default {"payBtn":"PayButton_payBtn__lnuG8"};